import React, { useContext } from 'react';
import { SafeAreaView, ScrollView, Text } from 'react-native';
import { ApolloProvider } from '@apollo/client';
import styled from 'styled-components/native';
import DataTable from '@preflighttech/preflight-tables';

import Footer from 'app/src/components/Footer';
import Home from 'app/src/components/Home';
import Menu from 'app/src/components/Menu';
import ClientContext from 'app/src/contexts/ClientContext';
import Routes from 'app/src/routes';
import { Router } from 'app/src/utils/routing';

const Screen = styled(SafeAreaView)`
  min-height: 100%;
`;

const Content = styled(ScrollView)`
  margin: 20px;
  flex: 1;
`;

const Main = () => {
  const { apolloClient } = useContext(ClientContext);

  return (
    <Router>
      <ApolloProvider client={apolloClient}>
        <Screen>
          <Menu />

          <Content>
            <DataTable.Provider
              pageLength={25}
              lengthMenu={ [10, 25, 50, 'All'] }
              htmlTable
            >
              <Routes />
            </DataTable.Provider>
          </Content>

          <Footer />
        </Screen>
      </ApolloProvider>
    </Router>
  );
};

export default Main;
